import React, { useEffect, useState, useMemo } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { useCookies } from 'react-cookie';



import './App.css';
import LoginPage from './pages/login'
import HomePage from "./pages/homepage";
import { AddInventory, ViewInventory, ViewInventoryDetails, AddPreparation, AddWastage } from "./pages/inventory";
import { AddBill, ViewBillsList, ViewBillDetails } from './pages/Bills';
import PaperWrapper from "./components/page_wrapper";
import { ViewOrders } from './pages/Orders';



const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light'
  },
});


function App() {
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [cookies, setCookies] = useCookies(['divash-admin-theme']);

  useEffect(() => {
    if (!cookies['divash-admin-theme']) {
      setCookies('divash-admin-theme', "light", { path: '/' });
    }
  }, [cookies, setCookies]);

  const theme = useMemo(
    () => cookies['divash-admin-theme'] === 'light' ? lightTheme : darkTheme,
    [cookies['divash-admin-theme']]
  );

  const showErrorMessage = (message) => {
    setSnackBarMessage(message);
    setAlertSeverity("error");
    setShowSnackBar(true);
  };

  const showSuccessMessage = (message) => {
    setSnackBarMessage(message);
    setAlertSeverity("success");
    setShowSnackBar(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setShowSnackBar(false);
  };

  return (
    <ThemeProvider theme={theme} >
      <CssBaseline />
      <BrowserRouter>
        <PaperWrapper theme={cookies['divash-admin-theme']} changeTheme={(theme) => {
          setCookies('divash-admin-theme', theme);
        }}>
          <Snackbar
            open={showSnackBar}
            autoHideDuration={30000}
            onClose={handleSnackbarClose}
          >
            <Alert
              onClose={handleSnackbarClose}
              variant="filled"
              severity={alertSeverity}
            >
              {snackBarMessage}
            </Alert>
          </Snackbar>
          <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <Routes>
              <Route path="/" element={<LoginPage showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              {/* Removed redundant index route */}
              <Route path="/home" element={<HomePage showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/inventory/add/status" element={<AddInventory showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/inventory/add/preparation" element={<AddPreparation showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/inventory/view" element={<ViewInventory showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/inventory/view/details/*" element={<ViewInventoryDetails showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/inventory/add/wastage/" element={<AddWastage route="wastage" showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/inventory/add/usage/" element={<AddWastage route="usage" showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/bill/add" element={<AddBill showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/bill/view" element={<ViewBillsList showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/bill/view/*" element={<ViewBillDetails showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route path="/orders/view" element={<ViewOrders showErrorMessage={showErrorMessage} showSuccessMessage={showSuccessMessage} />} />
              <Route
                path="*"
                element={
                  <>TODO</>
                }
              />
            </Routes>
          </CookiesProvider>
        </PaperWrapper>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
